import { render, staticRenderFns } from "./modal-info-params.component.vue?vue&type=template&id=08d38d84&scoped=true"
import script from "./modal-info-params.component.vue?vue&type=script&lang=js"
export * from "./modal-info-params.component.vue?vue&type=script&lang=js"
import style0 from "./modal-info-params.component.vue?vue&type=style&index=0&id=08d38d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d38d84",
  null
  
)

export default component.exports